const BACKEND_URL = "https://reflex-backend.alfaoir1.workers.dev";

// Login
export const loginUser = async (email, password) => {
  const res = await fetch(`${BACKEND_URL}/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
};

// Get current user profile from token
export const getProfile = async () => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${BACKEND_URL}/profile`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// Register (for future use)
export const registerUser = async (email, password) => {
  const res = await fetch(`${BACKEND_URL}/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
};